module.exports = __webpack_public_path__ + "img/Add-Slider-Advertisement.6dd6b439.svg";